<div class="student-list">

  <h3 class="student-list-title">
    認識済みお子様 ({{ students?.length ?? 0 }}名)
  </h3>

  <div class="student-items">
    <app-student-item
      *ngFor="let student of students"
      [student]="student">
    </app-student-item>
  </div>

</div>